import { render, staticRenderFns } from "./ChallengesEvaluated.vue?vue&type=template&id=c5ab1380&"
import script from "./ChallengesEvaluated.vue?vue&type=script&lang=js&"
export * from "./ChallengesEvaluated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports